import type { ResolvedMonospaceSpace } from '#layers/data-model/types/schema/resolved-schema';
import { useRouter } from '#app/composables/router';
import { useStore } from '#imports';
import { useUpdateSpaceRoutes } from '#layers/spaces/utils/routes';

interface UpdateProjectSpaceRoutesOptions {
	spaces: ResolvedMonospaceSpace[];
	skipCurrentRouteUpdate?: boolean;
}

export function useProjectSpaceRoutes() {
	const store = useStore();
	const router = useRouter();
	const { updateRoutes } = useUpdateSpaceRoutes();

	return {
		loadProjectSpaceRoutes,
		removeProjectSpaceRoutes,
		updateProjectSpaceRoutes,
	};

	async function loadProjectSpaceRoutes() {
		const spaces = await store.MonospaceSpace.findMany({
			include: {
				sections: true,
			},
			fetchPolicy: 'fetch-only',
		});

		await store.MonospacePage.findMany({
			fetchPolicy: 'fetch-only',
		});

		await store.MonospaceBlock.findMany({
			fetchPolicy: 'fetch-only',
		});

		return spaces;
	}

	function updateProjectSpaceRoutes(options: UpdateProjectSpaceRoutesOptions) {
		updateRoutes({
			spaces: options.spaces,
			skipCurrentRouteUpdate: options.skipCurrentRouteUpdate,
		});
	}

	async function removeProjectSpaceRoutes() {
		const previousSpaces = await store.MonospaceSpace.findMany();

		for (const space of previousSpaces) {
			router.removeRoute(space.id);
		}
	}
}
